import { removeAreaState } from '../area';

/**
 * @param {MapSearch} ctx - the map search context
 */
async function removeArea( ctx, event ) {
    const options = Object.assign( {}, {
        search: true,
    }, event.detail || {} );

    ctx.setLoading( true );

    ctx.locationIndicator.clear();

    removeAreaState( ctx.map );

    if ( !options.search ) {
        ctx.setLoading( false );
        return;
    }

    const propertyParams = new URLSearchParams( ctx.previousSearchState );

    propertyParams.delete( 'area' );

    const updateParams = {
        fetchFeatures: false,
        fetchProperties: true,
        propertySearchURL: ctx.propertySearchURL,
        propertySearchParams: propertyParams,
    };

    ctx.previousSearchState = propertyParams.toString();

    await ctx.update( updateParams );

    ctx.setLoading( false );
}

export {
    removeArea,
};
